import { envService } from "../config/env";
import { Table, Typography, Space, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { ThemedModal } from "./ThemedModal";

const { Text } = Typography;

interface EnvVariable {
  key: string;
  value: string;
}

const EnvironmentInfoContent = () => {
  const env = envService.getEnv();
  const envData: EnvVariable[] = Object.entries(env).map(([key, value]) => ({
    key,
    value: value || "-",
  }));

  const columns: ColumnsType<EnvVariable> = [
    {
      title: "Variable",
      dataIndex: "key",
      key: "key",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text) => <Text>{text}</Text>,
    },
  ];

  const getEnvironmentTag = () => {
    const type = envService.isProduction()
      ? { color: "green", text: "Production" }
      : envService.isStaging()
        ? { color: "orange", text: "Staging" }
        : envService.isDevelopment()
          ? { color: "blue", text: "Development" }
          : envService.isLocal()
            ? { color: "gray", text: "Local" }
            : { color: "default", text: "Unknown" };

    return <Tag color={type.color}>{type.text}</Tag>;
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Space direction="vertical" size="small">
        <Space align="center">
          <Text strong>Environment Type:</Text>
          {getEnvironmentTag()}
        </Space>
        <Text>
          <Text strong>Current Branch: </Text>
          {envService.getCurrentBranch() || "Unknown"}
        </Text>
        <Text>
          <Text strong>Build Job ID: </Text>
          {envService.getBuildJobId() || "Unknown"}
        </Text>
        <Text>
          <Text strong>Build Time: </Text>
          {envService.getBuildTime() || "Unknown"}
        </Text>
      </Space>

      <Table
        columns={columns}
        dataSource={envData}
        pagination={false}
        size="small"
        bordered
        style={{ marginTop: 16 }}
      />
    </Space>
  );
};

const EnvironmentInfo = {
  show: () => {
    if (envService.isProduction()) {
      return;
    }

    ThemedModal.info({
      title: "Environment Information",
      content: <EnvironmentInfoContent />,
      width: 800,
      maskClosable: true,
    });
  },
};

export default EnvironmentInfo;
